<section class="prompt-suggestion" [attr.aria-label]="'chat.promptSuggestions.title' | translate">
	<div class="prompt-suggestion__header">
		@if (selectedSuggestion()) {
		<button type="button" class="prompt-suggestion__back" (click)="goBack()"
			[attr.aria-label]="'chat.promptSuggestions.back' | translate">
			<app-icon icon="fa-solid fa-arrow-left" color="currentColor" [width]="15" [height]="15" />
		</button>
		} @else {
		<span class="prompt-suggestion__sparkle" aria-hidden="true">
			<app-icon icon="icon-stars-solid.svg" color="var(--safegpt-primary)" [width]="20" [height]="20" />
		</span>
		}
		<div class="prompt-suggestion__heading">
			@if (selectedSuggestion(); as suggestion) {
			<h2>{{ suggestion.title }}</h2>
			} @else {
			<h2>{{ 'chat.promptSuggestions.title' | translate }}</h2>
			<p>{{ 'chat.promptSuggestions.subtitle' | translate }}</p>
			}
		</div>
		<button type="button" class="prompt-suggestion__icon-button" (click)="closed.emit()"
			[attr.aria-label]="'chat.promptSuggestions.close' | translate">
			<app-icon icon="fa-solid fa-xmark" color="currentColor" [width]="15" [height]="15" />
		</button>
	</div>

	@if (selectedSuggestion(); as suggestion) {
	<p>{{ suggestion.description }}</p>
	}

	@if (!loading() && selectedSuggestion()) {
	<ul class="prompt-suggestion__bullets">
		@for (line of explanationLines(); track line) {
		<li>{{ line }}</li>
		}
	</ul>
	}

	<div class="prompt-suggestion__list">
		@if (loading()) {
		<div class="prompt-suggestion__loading">{{ 'chat.promptSuggestions.loading' | translate }}</div>
		} @else if (selectedSuggestion(); as suggestion) {
		<div class="prompt-suggestion__detail">
			<div class="prompt-suggestion__examples">
				<strong>{{ 'chat.promptSuggestions.examples' | translate }}</strong>
				@for (example of suggestion.explaination.examples; track example.example) {
				<button type="button" class="prompt-suggestion__example" (click)="exampleSelected.emit(example)">
					<span>{{ example.example }}</span>
					<app-icon icon="fa-solid fa-plus" color="currentColor" [width]="15" [height]="15" />
				</button>
				}
			</div>
		</div>
		} @else {
		@for (suggestion of suggestions(); track suggestion.title + suggestion.description) {
		<button type="button" class="prompt-suggestion__item" (click)="selectSuggestion(suggestion)">
			<span class="prompt-suggestion__item-icon" aria-hidden="true">
				<app-icon [icon]="suggestion.icon" color="currentColor" [width]="15" [height]="15" />
			</span>
			<span class="prompt-suggestion__item-text">
				<strong>{{ suggestion.title }}</strong>
				<span>{{ suggestion.description }}</span>
			</span>
			<app-icon class="prompt-suggestion__arrow" icon="fa-solid fa-arrow-right" color="currentColor" [width]="15" [height]="15" />
		</button>
		}
		}
	</div>
</section>